import React from 'react';

import {
  MESSAGE_SUCCES,
	MESSAGE_INFO,
	MESSAGE_ERROR,LOGOUT,
	SET_USER
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";

import User from "api/User";
import UserModel from 'models/User';

import { connect } from "react-redux";

import {Edit as ProfileEditView} from 'views/profile/Edit';
import Button from 'react-bootstrap/Button';
import { messageActions } from 'redux/messageSlice';
import messageSlice from 'redux/messageSlice';

class ProfileEditController extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false, user: new UserModel() , validation: false};
	}

	async componentDidMount() {
		var {user} = this.state;
		const { dispatch, isLoggedIn } = this.props;
		if(isLoggedIn) {
			try {
				let t = (	<a href="#" onClick={this.test}  className="btn-circle">
								<svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24">
									<path d="M12,10a4,4,0,1,0,4,4A4,4,0,0,0,12,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,16Z"/><path d="M22.536,4.122,19.878,1.464A4.966,4.966,0,0,0,16.343,0H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V7.657A4.966,4.966,0,0,0,22.536,4.122ZM17,2.08V3a3,3,0,0,1-3,3H10A3,3,0,0,1,7,3V2h9.343A2.953,2.953,0,0,1,17,2.08ZM22,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2V3a5.006,5.006,0,0,0,5,5h4a4.991,4.991,0,0,0,4.962-4.624l2.16,2.16A3.02,3.02,0,0,1,22,7.657Z"/>
								</svg>
							</a>
);
				
				dispatch(showLoader(true, t));
				var response = await User.getUser();
				user.addData( response.data );
				this.setState({user: user});
				dispatch(hideLoader());
			} catch(err) {
				console.log("err", err);
				dispatch(hideLoader());
				//dispatch({ type: LOGOUT });
			}
		}
	}
	
	test= (event) => {
		event.preventDefault();
		const {user} = this.state;
		this.onSaveHandler(user);
	}
	
	onSaveHandler = (data) => {
		const { dispatch } = this.props;
		
		dispatch(showLoader());
		User.updateUser(data)
			.then((response) =>   {
			dispatch({ type: SET_USER, payload: { user : response.data.data } });
			dispatch({ type: MESSAGE_SUCCES, "message": "De gegevens zijn opgeslagen!", "header": "Succes" });
			dispatch(messageSlice.actions.submitMessage({action: SET_USER, payload: { user : response.data.data }}));
			dispatch(hideLoader());
		})
		.catch((err) => {
			if(err.response.status == 422) {
				this.setState({validation: err.response.data.data});
				dispatch({ type: MESSAGE_INFO, "message": "In het formulier zijn validatie fouten gevonden!", "header": "Validatie fouten" });
				dispatch(hideLoader());
			}
		});		
		//this.c++;
		//const { dispatch } = this.props;
			//dispatch({ type: MESSAGE_ERROR, "message": "Succes "+this.c, "header": "Info header" });
//		let navigate = useNavigate();
//		navigate('/');
			
	}

	render() {
		const {user, validation } = this.state;
		return <ProfileEditView initData={user} onSave={this.onSaveHandler} validation={validation}/>;
	}

}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(ProfileEditController);